import axios from 'axios';

const login = (credentials) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/authentication/authenticate`,
    {
      email: credentials.username,
      password: credentials.password
    }
  );
}

const logout = () => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/authentication/logout`
  );
}

export const authService = {
  login,
  logout
}
